import {
  SYS_BREAKPOINT_MD,
  SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_200_DARK,
} from '@oneaudi/unified-web-common';
import styled from 'styled-components';
import { dynamicStylingHelper } from '@oneaudi/vtp-shared';
import { SYS_BORDER_RADIUS_MD } from '@oneaudi/unified-web-alpha-common';

export const StyledImage = styled.img<{ isSinglePicture?: boolean }>`
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: ${(props) =>
    props.isSinglePicture &&
    dynamicStylingHelper('unset', `${SYS_BORDER_RADIUS_MD} ${SYS_BORDER_RADIUS_MD} 0 0`)};
`;

export const StyledPicture = styled.picture`
  font-size: 0;
`;

export const ImageContainer = styled.div<{ photoImage: boolean; isSinglePicture?: boolean }>`
  background-color: ${(props) =>
    props.photoImage ? SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT : SYS_COLOR_SURFACE_NEUTRAL_200_DARK};
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 0;
  border-radius: ${(props) =>
    props.isSinglePicture &&
    dynamicStylingHelper('unset', `${SYS_BORDER_RADIUS_MD} ${SYS_BORDER_RADIUS_MD} 0 0`)};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    aspect-ratio: 4/3;
  }
`;
